import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import api from '../api';
import { Observable } from 'rxjs';
import { MedicalRecordInfo, RequestMaster, MedRecordSummaryInfo, MedRecordPatientInfo } from '../../models/MedicalRecordInfo.model';
import { CoreConst } from '../../common/core.const';
import { RequestType } from '../../enums/RequestType.enum';
import { SummaryInfo } from '../../models/SummaryInfo.model';
import { VMMedRecordDocInfo } from '../../models/VMMedRecordDocInfo';
import { AppConfig } from '../app.config.service';

@Injectable()
export class MedicalRecordService {
  constructor(public http: HttpClient) { }

  GetMedicalRecords(treatments: string, medicalRecord: string, speciality: string, searchText?: string, DoiTuongId?: string, pageStart?: number): Observable<Array<MedicalRecordInfo>> {
    if(pageStart != undefined && pageStart != null && pageStart != NaN) {
    } else {
      pageStart =  0;
    }

    var x = (pageStart / AppConfig.Settings.TABLE_PAGE_LENGTH).toString();
    console.log('22222', pageStart);
    console.log('222221', x);

    const params = new HttpParams()
      .set('treatments', treatments.toString())
      .set('medicalRecord', medicalRecord.toString())
      .set('speciality', speciality.toString())
      .set('searchText', searchText ? searchText : '')
      .set('DoiTuongId', DoiTuongId.toString())
      .set('pageIndex', x);
    return this.http.get<Array<MedicalRecordInfo>>(`${api.url}${api.MedicalRecord.GetMedicalRecords}`, {params});
  }

  GetMedicalRecordsTCBA(treatments: string, medicalRecord: string, speciality: string, searchText?: string, pageStart?: number, DoiTuongId?: string,FromTime?:any,ToTime?:any,lookupPatient?:string): Observable<Array<MedicalRecordInfo>> {

    if(pageStart != undefined && pageStart != null && pageStart != NaN) {
    } else {
      pageStart =  0;
    }
   
    var x = (pageStart / AppConfig.Settings.TABLE_PAGE_LENGTH).toString();

    const params = new HttpParams()
      .set('treatments', treatments.toString())
      .set('medicalRecord', medicalRecord.toString())
      .set('speciality', speciality.toString())
      .set('searchText', searchText ? searchText : '')
      .set('DoiTuongId', DoiTuongId.toString())
      .set('StartTime', FromTime ==undefined?"":FromTime)
      .set('EndTime', ToTime==undefined?"":ToTime)
      .set('pageIndex', x)
      .set("lookupPatient",lookupPatient==undefined?"":lookupPatient);
    return this.http.get<Array<MedicalRecordInfo>>(`${api.url}${api.MedicalRecord.GetMedicalRecords}/tcba`, {params});
  }

  GetActiveMedicalRecords(reqType: string, treatments: string, medicalRecord: string, speciality: string, searchText?: string, DoiTuongId?: string, pageStart?: number, status?: string, code?: string, FromTime?: string,ToTime?:string): Observable<Array<MedicalRecordInfo>> {
    if (pageStart != undefined && pageStart != null && !Number.isNaN(pageStart)) {
    } else {
      pageStart = 0;
    }  
 

    var x = (pageStart / AppConfig.Settings.TABLE_PAGE_LENGTH).toString();

    const params = new HttpParams()
      .set('reqType', reqType.toString())
      .set('treatments', treatments.toString())
      .set('medicalRecord', medicalRecord.toString())
      .set('speciality', speciality.toString())
      .set('searchText', searchText)
      .set('DoiTuongId', DoiTuongId.toString())
      .set('pageIndex', x)
      .set('status', status)
      .set('code', code)
      //.set('FromTime', FromTime)
      //.set('ToTime', ToTime)

    return this.http.get<Array<MedicalRecordInfo>>(`${api.url}${api.MedicalRecord.GetActiveMedicalRecords}`, { params });
  }

  GetMasters(): Observable<Array<RequestMaster>> {
    return this.http.get<Array<RequestMaster>>(`${api.url}${api.Request.Master}`);
  }
  GetDSDoiTuong(): Observable<Array<RequestMaster>> {
    return this.http.get<Array<RequestMaster>>(`${api.url}${api.Authorize.DanhSachDoiTuong}`);
  }

  GetMedInfoDetail(id: string, reqType: string, version: number): Observable<MedicalRecordInfo> {
    var url;
    if (reqType == RequestType.TCBA) {
      url = `${api.url}${api.MedicalRecord.MedicalRecord}/Approver/${id}`
    } else {
      url =`${api.url}${api.MedicalRecord.GetMedicalRecordDetail}/${id}`
    }
    const params = new HttpParams()
      .set('reqType', reqType.toString()).set('version', version.toString());
    return this.http.get<MedicalRecordInfo>(url, { params });
  }

  GetMedInfoDetailByApprover(id: string): Observable<MedicalRecordInfo> {
    return this.http.get<MedicalRecordInfo>(`${api.url}${api.MedicalRecord.MedicalRecord}/Approver/${id}`);
  }

  GetMedicalRecordsOfPatient(treatments: number, medicalRecord: number, speciality: number): Observable<Array<MedRecordPatientInfo>> {
    return this.http.get<Array<MedRecordPatientInfo>>(`${api.url}${api.MedicalRecord.MedicalRecord}/patients`);
  }

  GetDocumentsOfPatient(patientCode: string): Observable<Array<VMMedRecordDocInfo>> {
    return this.http.get<Array<VMMedRecordDocInfo>>(`${api.url}${api.MedicalRecord.MedicalRecord}/patients/${patientCode}`);
  }

  GetMedInfoDocDetail(id: string): Observable<any> {
    if (!/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(id))
      return new Observable<any>();
    return this.http.get<any>(`${api.url}${api.MedicalRecord.MedicalRecord}/File/Doc/${id}`, {
      responseType: 'arraybuffer' as 'json',
    });
  }

  GetSummary(): Observable<SummaryInfo> {
    
    return this.http.get<SummaryInfo>(`${api.url}${api.MedicalRecord.MedicalRecord}/Summary`);
  }

  SaveMedicalRecordSummary(id: string, summaryInfo: MedRecordSummaryInfo): Observable<MedRecordSummaryInfo> {
    return this.http.put<MedRecordSummaryInfo>(`${api.url}${api.MedicalRecord.SaveMedicalRecordSummary}/${id}`, summaryInfo);
  }

  GetRecent(): Observable<Array<MedicalRecordInfo>> {
    return this.http.get<Array<MedicalRecordInfo>>(`${api.url}${api.MedicalRecord.MedicalRecord}/Recent`);
  }
}

